<template>
    <modal name="helpModal" height="auto" width="640px" :scrollable="true">
        <div class="modal-content">
            <div class="modal-header">
                <div>
                    <inline-svg src="/assets/img/logo/logo_primary_and_white.svg"/>
                </div>
                <div>
                    <h4 class="modal-title dashboard-card-title ps-2">How can I help?</h4>
                    <div class="modal-subtitle-gray ps-2">
                        Your feedback will help me to learn how I can do better
                    </div>
                </div>
                <button type="button"
                        class="btn-close"
                        style="margin-top: -40px"
                        data-dismiss="modal"
                        aria-hidden="true"
                        @click="$modal.hide('helpModal')">
                </button>
            </div>

            <div class="divider --top-20"></div>
            <form-textarea class="p-3" rows="10" placeholder="I'm having trouble with..."  label="Message" v-model="message"/>
            <div class="divider --vertical-12"></div>
            <div class="modal-footer">
                <btn class="btn-outline-light btn-lg flex-1" @click="$modal.hide('helpModal')">Cancel</btn>
                <btn class="btn-primary btn-lg flex-1" :loading="loading" :disabled="!message" @click="sendMessage">
                    Save
                </btn>
            </div>
        </div>
    </modal>
</template>

<script>

export default {
    name: "HelpModal",
    data() {
        return {
            loading: false,
            message: ''
        }
    },
    methods: {
        sendMessage() {
            this.loading = true;
            this.$http.post("/help/send-message", {'message': this.message})
                .then((res) => {
                    this.loading = false;
                    this.message = '';
                    this.$modal.hide('helpModal')
                })
                .catch((error) => {
                    this.loading.data = false;
                });
        }
    }
}
</script>

<style scoped>

</style>
